






import Vue from "vue";
import { Component } from "vue-property-decorator";
import PatientList from "@/components/patient/PatientList.vue";

@Component({
  components: {
    PatientList
  }
})
export default class ProfessionalPage extends Vue {}
